export default "__VITE_ASSET__B2tv6f3G__"